export const ecoStickerType: { [key: number]: string } = {
  1: 'zero',
  2: 'eco',
  3: 'C',
  4: 'B',
};
